/**
 * The duel's clock in words, the same on the screen's panel and the headset's plaque
 * (client-arena:quality#9): the ring used to appear with no warning at 90 s, and a duel the clock
 * ended said "Defeated" with no reason.
 */

/** Seconds before sudden death that the panels start to warn of it. */
export const SUDDEN_DEATH_WARNING_SECONDS = 10;

/** "Sudden death in 0:07" in the last seconds before the arena starts to burn; null otherwise. */
export function suddenDeathWarning(
  time: number,
  suddenDeathAt: number,
  started: boolean,
): string | null {
  const left = suddenDeathAt - time;
  if (started || !(left > 0) || left > SUDDEN_DEATH_WARNING_SECONDS) return null;
  const seconds = Math.ceil(left);
  return `Sudden death in ${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}

/** Why a duel the clock ended went the way it did (the core's `timeout` verdict). */
export const TIME_UP = 'Time up: the fitter fighter wins';
